import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedin, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import AsyncentricLogo from '../images/asyncentric.png';

library.add(faFacebook, faLinkedin, faTwitter, faInstagram);

const styles = theme => ({
    root: {
        backgroundColor: '#222222',
    },
    logoContainer: {
        textAlign: 'center'
    },
    logoImage: {
        width: '80px',
        height: '80px'
    },
    companyName: {
        textAlign: 'center',
        letterSpacing: '1px',
        color: '#eeeeee',
        fontWeight: '700',
    },
    container: {
        width: '90%',
        margin: '0 auto',
        padding: '0 10px'
    },
    navigation: {
        textAlign: "center",
        fontSize: '1rem',
        fontWeight: 'bold',
        letterSpacing: '1px',
        marginBottom: '10px',
        color: '#eeeeee',
        [theme.breakpoints.up('xl')]: {
            fontSize: '1.2rem',
        },
    },
    navSubText: {
        fontSize: '.8rem',
        letterSpacing: '1px',
        color: '#eeeeee',
        [theme.breakpoints.up('xl')]: {
            fontSize: '1rem',
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    inputField: {
        marginBottom: theme.spacing.unit,
        color: "#FFFFFF",
    },
    input: {
        color: '#eeeeee',
    },
    button: {
        margin: '20px 0',
        color: '#eeeeee',
    },
    social: {
        textAlign: 'center',
        marginBottom: '30px',
        '& a': {
            marginRight: '15px',
            fontSize: '1.5rem',
        },
        [theme.breakpoints.down('sm')]: {
            textAlign: 'center'
        }
    },
    facebook: {
        color: '#3b5998',
    },
    twitter: {
        color: '#1DA1F2',
    },
    linkedin: {
        color: '#0077B5',
    },
    instagram: {
        color: '#fb3958',
    },
    copyRightText: {
        padding: '20px auto',
        textAlign: 'center',
        color: '#222222',
        backgroundColor: "#EEEEEE",
        fontSize: '8px',
        fontWeight: '400',
        [theme.breakpoints.up('xs')]: {
            fontSize: '12px',
        },
    }
});

const Footer = (props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <footer>
                <br />
                <div className={classes.logoContainer}>
                    <img src={AsyncentricLogo} alt="Asyncentric Logo" className={classes.logoImage}></img>
                </div>
                {/* <Typography variant="h5" className={classes.companyName}>ASYNCENTRIC</Typography> */}
                <br />
                <Grid container className={classes.container} spacing={32}>
                    <Grid container item xs={12} sm={4} md={4} lg={4} direction="column">
                        <Typography variant="h6" className={classes.navigation}>
                            ABOUT
                    </Typography>
                        <div>
                            <Typography variant="body2" paragraph className={classes.navSubText}>
                                Asyncentric is a Software Products, Solutions and Services organization offering progressive end-to-end Web & App Development to customers and focused on becoming global provider for IT solutions.
                    </Typography>
                        </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4} direction="column">
                        <Typography variant="h6" className={classes.navigation}>CONNECT</Typography>
                        <div className={classes.social}>
                            <a className={classes.facebook} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/Asyncentric-Technologies-563674104102164/"><FontAwesomeIcon icon={faFacebook} /></a>
                            <a className={classes.twitter} target="_blank" rel="noopener noreferrer" href="http://www.twitter.com"><FontAwesomeIcon icon={faTwitter} /></a>
                            <a className={classes.linkedin} target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/asyncentric"><FontAwesomeIcon icon={faLinkedin} /></a>
                            <a className={classes.instagram} target="_blank" rel="noopener noreferrer" href="http://www.instagram.com"><FontAwesomeIcon icon={faInstagram} /></a>
                        </div>
                    </Grid>
                    <Grid container item xs={12} sm={4} md={4} lg={4} direction="column">
                        <Typography variant="h6" className={classes.navigation}>
                            ADDRESS
                    </Typography>
                        <div>
                            <Typography variant="body2" paragraph className={classes.navSubText}>
                                Majarathi Apartment, Near Gangotri Hotel, Chitralaya Boisar - 401504
                    </Typography>
                            <Typography variant="body2" paragraph className={classes.navSubText}>
                                contact@asyncentric.com
                    </Typography>
                            <Typography variant="body2" paragraph className={classes.navSubText}>
                                {/* +918888438568 */}
                                +918668956967 / +917558219710
                    </Typography>
                        </div>
                    </Grid>
                </Grid>
                <div className={classes.copyRightText}>&copy;{new Date().getFullYear()}. DEVELOPED BY ASYNCENTRIC TECHNOLOGIES.</div>
            </footer>
        </div>
    );
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Footer);